// Copyright 2018 The MathWorks, Inc.

define([
    "dojo/_base/declare",
    "mw-form/PushButton",
    "MW/toolstrip/mixins/property/TypeMixin",
    "./RegionMixin"
], function (declare, PushButton, TypeMixin, RegionMixin) {

    return declare([PushButton, TypeMixin, RegionMixin], {
    });
});